import React, { FC } from "react";

export const TouchableView: FC<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = (props) => {
  return (
    <div className="cursor-pointer hover:opacity-80">
      <div {...props}>{props.children}</div>
    </div>
  );
};
